import { marked } from "marked";
import { Children, useEffect, useState } from "react";

import { cx } from "@/utils";

import parseSections from "./parse-sections";
import Section from "./section";

export default function Report({ report, setHeadings }) {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    const sections = parseSections(marked(report));
    const headings = sections.map((section) => ({
      text: section.heading,
      id: section.id,
    }));

    setSections(sections);
    setHeadings(headings);
  }, []);

  const isOverviewSection = (sectionId) => sectionId === sections[0]?.id;

  return (
    <article
      id="report"
      className={cx(
        "prose prose-blue prose-headings:font-medium prose-p:text-cp-grey-800 prose-li:text-cp-grey-800 prose-li:marker:text-cp-grey-800 max-w-none",
      )}
    >
      <h1>AI Forensic Financial Analysis Report</h1>
      {Children.toArray(
        sections.map(({ id, content }) =>
          isOverviewSection(id) ? (
            <section id={id} dangerouslySetInnerHTML={{ __html: content }} />
          ) : (
            <Section id={id} content={content} />
          ),
        ),
      )}
    </article>
  );
}
